import { getSPDataWithParams, postSPDataWithParams } from 'src/supportPortal/services/services'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'

const BASE = '/api/secure/cc/support/auditor-management'

/** Practitioner-restricted candidate search for the assign dialog. Returns []. */
export async function searchAuditorPractitioners(search) {
  const resp = await getSPDataWithParams(`${BASE}/practitioners/search`, { search })
  if (resp?.status === 200 && isCommonResponseSuccessfulV2(resp)) {
    return getDataMapFromCommonResponse(resp)?.practitioners || []
  }
  return []
}

/** Lists every auditor profile (enriched with user + practitioner snippets). Returns []. */
export async function listAuditorProfiles() {
  const resp = await getSPDataWithParams(`${BASE}/auditors`)
  if (resp?.status === 200 && isCommonResponseSuccessfulV2(resp)) {
    return getDataMapFromCommonResponse(resp)?.auditorProfiles || []
  }
  return []
}

/**
 * Assigns one/both auditor roles + creates/updates the auditor profile.
 * payload: { userId, practitionerId, auditorRoleIds, eventTypePermissions, note, reason }
 * Returns { ok, message, data }.
 */
export async function assignAuditorRoles(payload) {
  const resp = await postSPDataWithParams(`${BASE}/assign`, payload)
  const ok = resp?.status === 200 && isCommonResponseSuccessfulV2(resp)
  return {
    ok,
    message: resp?.data?.message || (ok ? 'Auditor role assigned' : 'Failed to assign auditor role'),
    data: ok ? getDataMapFromCommonResponse(resp) : null,
  }
}

/**
 * Revokes a single auditor role and reconciles the profile.
 * payload: { userId, practitionerId, roleId }
 * Returns { ok, message }.
 */
export async function revokeAuditorRole(payload) {
  const resp = await postSPDataWithParams(`${BASE}/revoke`, payload)
  const ok = resp?.status === 200 && isCommonResponseSuccessfulV2(resp)
  return {
    ok,
    message: resp?.data?.message || (ok ? 'Auditor role revoked' : 'Failed to revoke auditor role'),
  }
}
